import styled from "@emotion/styled";
import {  Typography, Badge } from "antd";
import { FC } from "react";
import { BankAllListResponse, bankingData } from "services/interface";
import noImage from "assets/images/no-image.png";

interface BanksProfileProps {
  data: bankingData | undefined;
}
const BanksProfile: FC<BanksProfileProps> = ({
  data
}) => {
  return (
      <CardWrapper>
        <CardContentWrapper>
          <Badge>
            <ImageWrapper>
              <img
                src={data?.image ?? noImage}
                width={"100%"}
                height={"100%"}
                alt="bankImages"
                style={{ objectFit: "cover" }}
              />
            </ImageWrapper>
          </Badge>
          <ContentText>
            <TextWrapper>
              <Typography.Text >
                {data?.bank_name ?? ''}
              </Typography.Text>
              <Typography.Text>
                {data?.account_name ?? ''}
              </Typography.Text>
              <Typography.Text >
                {data?.account_no ?? ''}
              </Typography.Text>
            </TextWrapper>
          </ContentText>
        </CardContentWrapper>
      </CardWrapper>

  );
};

export default BanksProfile;

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-color: #efefef;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 5px 0px 5px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  height: 80px;
  width: auto;
  border-radius: 0px;
  cursor: pointer;
`;

const ContentText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-left: 10px;
  margin-top: 10px;
`;